// extracted by mini-css-extract-plugin
export var htmlPreview = "_v2-0";